import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => createStyles({
  summary: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'flex-start',
    marginTop: '24px',
  },
  expandIcon: {
    marginBottom: "-15px",
    marginTop: "-15px",
    '&$summaryExpanded': {
      transform: "rotate(90deg)",
      '& path': {
        fill: '#65AC1E'
      }
    }
  },
  summaryContent: {
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    paddingLeft: theme.spacing(1),
    '&$summaryExpanded': {
      margin: 0,

    }
  },
  summaryExpanded: {
  },
  heading: {
    '&.opened': {
      color: '#65AC1E',
    },
    fontWeight: 'bold',
    fontSize: "12px",
    lineHeight: "180%",
    textTransform: "uppercase",
    color: 'rgba(39, 58, 57, 0.8)',
  },
  secondaryHeading: {
    '&.opened': {
      display: 'none',
    },
    color: 'rgba(39, 58, 57, 0.5)',
    fontSize: '12px',
    lineHeight: '180%',
  },
}));
